import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API } from '../../App';
import { toast } from 'sonner';
import { useNavigate } from 'react-router-dom';

const Dashboard = ({ user }) => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      const response = await axios.get(`${API}/admin/dashboard`, { withCredentials: true });
      setStats(response.data);
    } catch (error) {
      toast.error('Failed to load dashboard');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="loading-screen"><div className="spinner"></div></div>;
  }

  return (
    <div>
      <h1 style={{ fontSize: '32px', fontWeight: '800', marginBottom: '32px' }}>Admin Dashboard</h1>

      <div className="stats-grid" data-testid="admin-stats-grid">
        <div className="stat-card" style={{ cursor: 'pointer' }} onClick={() => navigate('/admin/orders?tab=all')} data-testid="stat-total">
          <div className="stat-label">Total Orders</div>
          <div className="stat-value">{stats?.total || 0}</div>
        </div>
        <div className="stat-card" style={{ cursor: 'pointer', borderLeftColor: '#997404' }} onClick={() => navigate('/admin/orders?tab=pending')} data-testid="stat-pending">
          <div className="stat-label">Pending</div>
          <div className="stat-value" style={{ color: '#997404' }}>{stats?.pending || 0}</div>
        </div>
        <div className="stat-card" style={{ cursor: 'pointer', borderLeftColor: '#1E40AF' }} onClick={() => navigate('/admin/orders?tab=in_process')} data-testid="stat-in-process">
          <div className="stat-label">In Process</div>
          <div className="stat-value" style={{ color: '#1E40AF' }}>{stats?.in_process || 0}</div>
        </div>
        <div className="stat-card" style={{ cursor: 'pointer', borderLeftColor: '#065F46' }} onClick={() => navigate('/admin/orders?tab=approved')} data-testid="stat-approved">
          <div className="stat-label">Approved</div>
          <div className="stat-value" style={{ color: '#065F46' }}>{stats?.approved || 0}</div>
        </div>
        <div className="stat-card" style={{ cursor: 'pointer', borderLeftColor: '#991B1B' }} onClick={() => navigate('/admin/orders?tab=rejected')} data-testid="stat-rejected">
          <div className="stat-label">Rejected</div>
          <div className="stat-value" style={{ color: '#991B1B' }}>{stats?.rejected || 0}</div>
        </div>
      </div>

      <div className="card" style={{ marginTop: '32px' }}>
        <h2 style={{ fontSize: '20px', fontWeight: '700', marginBottom: '16px' }}>Quick Actions</h2>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '16px' }}>
          <div
            onClick={() => navigate('/admin/orders')}
            style={{
              padding: '24px',
              background: '#FDB515',
              borderRadius: '16px',
              color: '#000',
              fontWeight: '600',
              cursor: 'pointer',
              transition: 'all 0.2s ease'
            }}
          >
            <div style={{ fontSize: '18px', marginBottom: '8px' }}>Manage Orders</div>
            <div style={{ fontSize: '13px', opacity: 0.8 }}>Review and approve pending orders</div>
          </div>
          <div
            onClick={() => navigate('/admin/products')}
            style={{
              padding: '24px',
              background: '#F5F5F5',
              borderRadius: '16px',
              color: '#1A1A1A',
              fontWeight: '600',
              cursor: 'pointer',
              transition: 'all 0.2s ease'
            }}
          >
            <div style={{ fontSize: '18px', marginBottom: '8px' }}>Manage Products</div>
            <div style={{ fontSize: '13px', color: '#666' }}>Edit pricing and services</div>
          </div>
          <div
            onClick={() => navigate('/admin/pricing')}
            style={{
              padding: '24px',
              background: '#F5F5F5',
              borderRadius: '16px',
              color: '#1A1A1A',
              fontWeight: '600',
              cursor: 'pointer',
              transition: 'all 0.2s ease'
            }}
          >
            <div style={{ fontSize: '18px', marginBottom: '8px' }}>Pricing Editor</div>
            <div style={{ fontSize: '13px', color: '#666' }}>Update public pricing page</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
